export default "__VITE_ASSET__Ce1cyb9o__"